import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password: pw });
      localStorage.setItem("ak_token", r.data.token);
      toast.success("Welcome back, Kim");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="admin-login-page">
      <p className="font-typewriter text-sm tracking-[0.3em] text-[#C84B31] mb-2">/ KIM'S DESK</p>
      <h1 className="font-brush text-6xl">SIGN IN</h1>
      <form onSubmit={submit} className="paper-card bg-[#FDFBF7] p-8 mt-6">
        <label className="block">
          <span className="font-typewriter text-xs tracking-widest text-[#4A4A4A]">EMAIL</span>
          <input data-testid="admin-email" className="input-typewriter mt-1" value={email} onChange={(e) => setEmail(e.target.value)} required type="email" />
        </label>
        <label className="block mt-6">
          <span className="font-typewriter text-xs tracking-widest text-[#4A4A4A]">PASSWORD</span>
          <input data-testid="admin-password" className="input-typewriter mt-1" value={pw} onChange={(e) => setPw(e.target.value)} required type="password" />
        </label>
        <button data-testid="admin-login-btn" disabled={loading} className="btn-brutal w-full mt-8">{loading ? "..." : "SIGN IN"}</button>
      </form>
    </div>
  );
}
